/*
 * Calendar Direct Link Display Dialog
 * Angular Module: trackerbase-app.views.tracking-calendar-view.calendar-event-info-panel.direct-link-dialog
 * Controller Name: calendarEventDirectLinkDialogCtl
 * Controller As: eventDirectLinkDialog
 *
 */

import Clipboard from "clipboard";

import Assert from "tbAssert";

const mModalInstance = new WeakMap();
const mDirectLink = new WeakMap();

const mShowCopyStatusMessage = new WeakMap();

const copyButtonElementId = "eventDirectLinkCopyButton";

class CalendarEventDirectLinkDialogController {
    constructor($scope,
                $timeout,
                $uibModalInstance,
                directLink)
    {
        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($timeout != null, "Assertion Failure: Missing Timeout Service Dependency");
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing UI Modal Instance Dependency");
        Assert.StrictAssert(directLink != null, "Assertion Failure: Missing Direct Link Input Dependency");

        mModalInstance.set(this, $uibModalInstance);
        mDirectLink.set(this, directLink);

        mShowCopyStatusMessage.set(this, false);

        let dialogClipboard = new Clipboard(`#${copyButtonElementId}`);

        dialogClipboard.on(
            "success",
            (e) => {
                if (e != null) {
                    e.clearSelection();

                    $timeout(() => {
                        mShowCopyStatusMessage.set(this, true);
                    }, 0);

                    $timeout(() => {
                        mShowCopyStatusMessage.set(this, false);
                    }, 2000);
                }
            }
        );

        $scope.$on("$destroy", () => {
            dialogClipboard.destroy();
        });
    }

    get showCopyStatusMessage() {
        return mShowCopyStatusMessage.get(this);
    }

    get eventDirectLink() {
        return mDirectLink.get(this);
    }

    ok() {
        mModalInstance.get(this).close();
    }
}

CalendarEventDirectLinkDialogController.$inject = [
    "$scope",
    "$timeout",
    "$uibModalInstance",
    "directLink"
];

CalendarEventDirectLinkDialogController.dependencies = [
    "ngSanitize",
    "ui.bootstrap"
];

CalendarEventDirectLinkDialogController.template = require("./CalendarEventDirectLinkDialog.tpl.html");

CalendarEventDirectLinkDialogController.controllerAs = "eventDirectLinkDialog";

export default CalendarEventDirectLinkDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/CalendarEventDirectLinkDialogController.js
// module id = QZqp
// module chunks = 1